@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';

.ghf {
  &-icon-button {
    padding: $spacing-8;
    border-radius: 40px;
    display: block;
    height: 24px;
    width: 24px;
    box-sizing: content-box;

    &:hover {
      border-radius: 50%;
      background-color: $color-header-hover-blue;
      svg, path {
        fill: $color-blue-default;
      }
    }

    &:active {
      border-radius: 50%;
      background-color: $color-header-hover-blue;
      svg, path {
        fill: $color-blue-default;
      }
    }
  }
}
